import { useEffect, useRef, useState } from 'react';
import { Play, Pause } from 'lucide-react';

const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
const BARS = Array.from({ length: 36 }, (_, i) => 0.35 + 0.65 * Math.abs(Math.sin(i * 1.7) * Math.cos(i * 0.6)));

export const AudioPlayer = ({ audio, poster, title }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [t, setT] = useState(0);
  const [dur, setDur] = useState(0);

  useEffect(() => () => ref.current?.pause(), []);

  const toggle = () => {
    const a = ref.current;
    if (a.paused) a.play(); else a.pause();
  };
  const seek = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    ref.current.currentTime = ((e.clientX - r.left) / r.width) * dur;
  };
  const pct = dur ? t / dur : 0;

  return (
    <div data-testid="case-audio-player" className="absolute inset-0 bg-ink">
      <img src={poster} alt={title} className="absolute inset-0 w-full h-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
      <audio
        ref={ref}
        src={audio.src}
        preload="metadata"
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onTimeUpdate={(e) => setT(e.currentTarget.currentTime)}
        onLoadedMetadata={(e) => setDur(e.currentTarget.duration)}
        onEnded={() => setT(0)}
      />
      <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8 text-cream">
        <p className="text-[11px] uppercase tracking-[0.25em] text-butter font-bold mb-2 flex items-center gap-2">
          <span className={`w-1.5 h-1.5 rounded-full bg-butter ${playing ? 'animate-pulse' : ''}`} />
          {audio.label || 'Jingle'}
        </p>
        <p className="font-slab font-bold text-xl sm:text-2xl mb-6">{audio.title || title}</p>
        <div className="flex items-center gap-4">
          <button
            type="button"
            data-testid="case-audio-toggle"
            onClick={toggle}
            aria-label={playing ? 'Pause jingle' : 'Play jingle'}
            className="shrink-0 w-14 h-14 rounded-full bg-butter text-ink border border-ink flex items-center justify-center hover:bg-cream transition-colors"
          >
            {playing ? <Pause size={22} /> : <Play size={22} className="ml-1" />}
          </button>
          <div className="flex-1">
            <div data-testid="case-audio-seek" onClick={seek} className="flex items-end gap-[3px] h-12 cursor-pointer">
              {BARS.map((h, i) => (
                <span
                  key={i}
                  className={`flex-1 rounded-sm transition-colors duration-150 ${i / BARS.length < pct ? 'bg-butter' : 'bg-cream/30'} ${playing && i / BARS.length < pct + 0.03 && i / BARS.length >= pct ? 'animate-pulse' : ''}`}
                  style={{ height: `${h * 100}%` }}
                />
              ))}
            </div>
            <div className="flex justify-between text-[11px] tracking-[0.15em] text-cream/60 mt-2">
              <span data-testid="case-audio-time">{fmt(t)}</span>
              <span>{dur ? fmt(dur) : '--:--'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
